module.exports = __webpack_public_path__ + "img/s5dbfc85a93c43.7dd274b4.jpg";